export default function ScoreRing({ value = 0, size = 160 }) {
  const radius = (size - 16) / 2;
  const circumference = 2 * Math.PI * radius;
  const pct = Math.max(0, Math.min(100, value));
  const offset = circumference - (pct / 100) * circumference;

  const color =
    pct >= 75 ? "#059669" : pct >= 55 ? "#2563EB" : pct >= 40 ? "#D97706" : "#E11D48";

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#E2E8F0"
          strokeWidth="10"
          fill="none"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={color}
          strokeWidth="10"
          strokeLinecap="round"
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 1s ease-out" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-jakarta text-4xl font-extrabold tracking-tight text-slate-900" data-testid="score-value">
          {pct}%
        </span>
        <span className="text-xs uppercase tracking-widest text-slate-500 mt-0.5">Compatibilité</span>
      </div>
    </div>
  );
}
